import axiosCall from './interceptor';
import URL from '../helper';

export const getAllEFaxUsers = async () => {
  const url = `${URL.BASE_URL}efax/user`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const addEfaxUser = async payload => {
  const url = `${URL.BASE_URL}efax/user`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const updateEFaxUser = async payload => {
  const url = `${URL.BASE_URL}efax/user`;
  let response = await axiosCall('put', url, payload);
  return response.data;
};

export const deleteEFaxUser = async id => {
  const url = `${URL.BASE_URL}efax/user?id=${id}`;
  let response = await axiosCall('delete', url);
  return response.data;
};
